<app-auth-page-layout>
  <div class="flex flex-col items-center justify-center flex-1 px-4">
    <div class="w-full max-w-md bg-white shadow-xl rounded-2xl p-8 text-center">

      <ng-container *ngIf="status() === 'loading'">
        <div class="flex flex-col items-center gap-4">
          <div class="w-10 h-10 border-4 border-brand-500 border-t-transparent rounded-full animate-spin"></div>
          <h2 class="text-xl font-semibold text-gray-700">Opening preview…</h2>
          <p class="text-gray-500 text-sm">Loading this content for the admin panel.</p>
        </div>
      </ng-container>

      <ng-container *ngIf="status() === 'error'">
        <div class="flex flex-col items-center gap-4">
          <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <svg class="w-8 h-8 text-red-600" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h2 class="text-2xl font-bold text-gray-800">Preview unavailable</h2>
          <p class="text-gray-600 text-sm">{{ message() }}</p>
          <p class="text-gray-500 text-xs">Go back to the admin panel and click the item again — preview links expire after 30 minutes.</p>
          <a routerLink="/"
            class="mt-2 inline-block bg-brand-500 text-white px-6 py-2 rounded-xl hover:bg-brand-600 transition">
            Go to Home
          </a>
        </div>
      </ng-container>

    </div>
  </div>
</app-auth-page-layout>
